import {
  CONFIRMED_GET_ASSIGNED_PATIENTS,
  FAILED_GET_ASSIGNED_PATIENTS,
  CONFIRMED_GET_TODAY_FOLLOWUPS,
  FAILED_GET_TODAY_FOLLOWUPS,
  CONFIRMED_GET_UPCOMING_FOLLOWUPS,
  FAILED_GET_UPCOMING_FOLLOWUPS,
  CONFIRMED_GET_EMERGENCY_PATIENTS,
  FAILED_GET_EMERGENCY_PATIENTS,
  CONFIRMED_MARK_EMERGENCY,
  FAILED_MARK_EMERGENCY,
  CONFIRMED_GET_DROPPED_PATIENTS,
  FAILED_GET_DROPPED_PATIENTS,
  CONFIRMED_UPDATE_PANCHKARMA,
  FAILED_UPDATE_PANCHKARMA,
  CONFIRMED_GET_71221_FOLLOWUPS,
  FAILED_GET_71221_FOLLOWUPS,
} from "./ServiceCallerType";

import {
  getAssignedPatient,
  getTodayFollowUpsReminder,
  getUpcomingFollowUpsReminder,
  getEmergencyPatients,
  markEmergencyPatient,
  getDroppedPatients,
  updatePanchkarmaTakenService,
  getFollowup71221Days,
  getAssignedLeads,
  getMedicineNotTakenService
} from "../../services/ServiceCallerService";

import { showErrorAlert } from "../../services/ErrorHandlingService";

// Unassigned Patients
export function fetchassignedPatientsAction() {
  return async (dispatch) => {
    try {
      const response = await getAssignedPatient();

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_ASSIGNED_PATIENTS,
          payload: response.data.data,
        });
        return { success: true, data: response.data.data };
      } else {
        throw new Error(response.data?.message || "Failed to fetch unassigned patients");
      }
    } catch (error) {
      dispatch({ type: FAILED_GET_ASSIGNED_PATIENTS, payload: error.message });
      showErrorAlert(error.message);
      throw error;
    }
  };
}

// Today Follow-ups
export function fetchTodayFollowUpsAction() {
  return async (dispatch) => {
    try {
      const response = await getTodayFollowUpsReminder();

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_TODAY_FOLLOWUPS,
          payload: response.data.data,
        });
        return { success: true, data: response.data.data };
      } else {
        throw new Error(response.data?.message || "Failed to fetch today's follow-ups");
      }
    } catch (error) {
      dispatch({ type: FAILED_GET_TODAY_FOLLOWUPS, payload: error.message });
      showErrorAlert(error.message);
      throw error;
    }
  };
}

// Upcoming Follow-ups
export function fetchUpcomingFollowUpsAction() {
  return async (dispatch) => {
    try {
      const response = await getUpcomingFollowUpsReminder();

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_UPCOMING_FOLLOWUPS,
          payload: response.data.data,
        });
        return { success: true, data: response.data.data };
      } else {
        throw new Error(response.data?.message || "Failed to fetch upcoming follow-ups");
      }
    } catch (error) {
      dispatch({ type: FAILED_GET_UPCOMING_FOLLOWUPS, payload: error.message });
      showErrorAlert(error.message);
      throw error;
    }
  };
}

export const fetchEmergencyPatientsAction = () => async (dispatch) => {
  try {
    const res = await getEmergencyPatients();
    dispatch({
      type: CONFIRMED_GET_EMERGENCY_PATIENTS,
      payload: res.data.data,
    });
  } catch (e) {
    dispatch({ type: FAILED_GET_EMERGENCY_PATIENTS, payload: e.message });
  }
};


// 🚨 MARK EMERGENCY
export const markEmergencyAction = (data) => async (dispatch) => {
  try {
    await markEmergencyPatient(data);

    dispatch({ type: CONFIRMED_MARK_EMERGENCY });

    // refresh list
    dispatch(fetchEmergencyPatientsAction());

  } catch (e) {
    dispatch({ type: FAILED_MARK_EMERGENCY, payload: e.message });
  }
};


// ⚠️ GET DROPPED PATIENTS
export const fetchDroppedPatientsAction = () => async (dispatch) => {
  try {
    const res = await getDroppedPatients();

    dispatch({
      type: CONFIRMED_GET_DROPPED_PATIENTS,
      payload: res.data.data,
    });

  } catch (e) {
    dispatch({ type: FAILED_GET_DROPPED_PATIENTS, payload: e.message });
  }
};

export function updatePanchkarmaTakenAction(payload) {
  return async (dispatch) => {
    try {
      const response = await updatePanchkarmaTakenService(payload);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_UPDATE_PANCHKARMA,
          payload: payload,
        });

        return { success: true };
      } else {
        throw new Error(
          response.data?.message || "Failed to update Panchkarma status"
        );
      }
    } catch (error) {
      dispatch({
        type: FAILED_UPDATE_PANCHKARMA,
        payload: error.message,
      });

      showErrorAlert(error.message);
      return { success: false };
    }
  };
}

export function fetchFollowup71221DaysAction() {
  return async (dispatch) => {
    try {
      const response = await getFollowup71221Days();

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_71221_FOLLOWUPS,
          payload: response.data.data,
        });

        return { success: true, data: response.data.data };
      } else {
        throw new Error(
          response.data?.message || "Failed to fetch 7/12/21 followups"
        );
      }
    } catch (error) {
      dispatch({
        type: FAILED_GET_71221_FOLLOWUPS,
        payload: error.message,
      });

      showErrorAlert(error.message);
      return { success: false };
    }
  };
}

export function fetchAssignedLeadsAction() {
  return async (dispatch) => {
    try {
      const response = await getAssignedLeads();

      if (response?.status === 200 && response.data?.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        throw new Error(response.data?.message || "Failed to fetch assigned leads");
      }
    } catch (error) {
      showErrorAlert(error.message);
      throw error;
    }
  };
}

export const fetchMedicineNotTakenAction = () => {
  return async (dispatch) => {
    try {
      const response = await getMedicineNotTakenService();

      if (response?.status === 200) {
        return {
          success: true,
          data: response.data?.data || [],
        };
      } else {
        throw new Error("Failed to fetch medicine not taken list");
      }
    } catch (error) {
      console.error("Medicine Not Taken Error:", error);
      return {
        success: false,
        message: error.message,
      };
    }
  };
};